
const data = [
  { text: 'Tela aberta', value: 1 },               // SCREEN_OPEN
  { text: 'Credor selecionado', value: 2 },        // CREDITOR_SELECTED
  { text: 'PDF do Plano baixado', value: 3 },      // PDF_DOWNLOADED
  { text: 'Termos aceitos', value: 4 },           // CHECKBOX_ALL_CONFIRMED
  { text: 'Plano selecionado', value: 5 },         // OPTION_SELECTED
  { text: 'PDF gerado', value: 6 },                // PDF_GENERATED
  { text: 'Tentativa envio PDF', value: 7 },        // PDF_UPLOADED
  { text: 'Erro no envio do PDF', value: 8 },      // PDF_UPLOAD_ERROR
  { text: 'Processo finalizado', value: 9 },       // PROCESS_FINISHED

]

export default [...data]
